<template>
  <div class="page">
    <div class="overlay"></div>
    <div class="header">
      <!-- <div class='leftBox'>
        <div class="logoDiv">
          <img src="../../assets/logo_RW.webp" alt="" class="logo">
          <p class="logoText">ROEWE</p>
        </div>
      </div>
      <div class='rightBox'>
        <div class="logoDiv">
          <img src="../../assets/logo_MG.webp" alt="" class="logo">
          <p class="logoText">SAICMG</p>
        </div>
      </div> -->
      <p class="title1">林肯 BM系统</p>
      <p class="titleShadow">林肯 BM系统</p>
      <p class="title2">Lincoln BM System</p>
      <p class="title2Shadow">Lincoln BM System</p>
      <!-- <p class="specialText">Financial Evaluation System</p> -->
    </div>
    <div class="LoginMain">
      <h2 class="login-title">登 录</h2>
      <div class="login-form">
        <span class="iconfont icon-jurassic_user"></span>
        <input style="color: white;" type="text" v-model="loginForm.username" @keydown.enter="onSubmit">
        <span class="iconfont icon-jiesuo"></span>
        <input style="color: white;" type="password" v-model="loginForm.password" @keydown.enter="onSubmit">
        <el-button class="btnLogin" type="primary" :style="{ background: '#FF6F1E', border: '1px solid #FF6F1E' }" round
          :loading="loading" @click="onSubmit">登 录</el-button>
      </div>
    </div>
    <div class="footer">
      <el-popover placement="left" :width="200" trigger="hover" content="沪ICP备2022024565号-1">
        <template #reference>
          <span class="ICP iconfont icon-icp"></span>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import '~/assets/css/iconfont.css'
import { useRouter } from 'vue-router'
import { useStore } from '~/store'
import { ElMessage } from 'element-plus'

const store = useStore()
const router = useRouter()

const loginForm = reactive({
  username: '',
  password: ''
})

const loading = ref(false)

const onSubmit = () => {
  if (!loginForm.username) {
    ElMessage.error('请输入用户名')
    return false;
  }
  if (loginForm.username.length < 3 || loginForm.username.length > 24) {
    ElMessage.error('用户名长度在3-24之间')
    return false;
  }
  if (!loginForm.password) {
    ElMessage.error('请输入密码')
    return false;
  }
  if (loginForm.password.length < 6 || loginForm.password.length > 20) {
    ElMessage.error('密码长度在6-20之间')
    return false;
  }
  loading.value = true
  store.login(loginForm).then((response) => {
    router.push('/')
  }).finally(() => {
    loading.value = false
  })
}
</script>

<style scoped>
.page {
  background-image: url("~/assets/loginBG2.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  position: relative;
}

.header,
.footer {
  height: calc((100% - 500px)/2)
}

.title1,
.title2,
.titleShadow,
.title2Shadow {
  width: calc(100% - 3px);
  height: 50px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  line-height: 0px;
  -webkit-background-clip: text;
  position: absolute;
  /*bottom: 0px;*/
  z-index: 100;
  text-align: center;
  color: #fff;
}

.title1 {
  font-size: 40px;
  width: 100%;
  top: calc((100% - 500px)/2 - 90px);
}

.titleShadow {
  height: 50px;
  font-size: 40px;
  position: absolute;
  z-index: 90;
  top: calc((100% - 500px)/2 - 93px);
  color: #000;
}

.title2 {
  font-size: 23px;
  width: 100%;
  letter-spacing: 1px;
  top: calc((100% - 500px)/2 - 40px);
}

.title2Shadow {
  font-size: 23px;
  height: 50px;
  letter-spacing: 1px;
  position: absolute;
  z-index: 90;
  top: calc((100% - 500px)/2 - 43px);
  color: #000;
}

.content {
  width: 100%;
  height: 500px;
  /* background-image: url('~/assets/bg4.webp'); */
  background-size: 100% 500px;
  position: absolute;
}

.footer>.iconList {
  position: absolute;
  z-index: 10;
  list-style: none;
  bottom: 40px;
  margin-left: 30px;
}

.footer>.iconList span {
  font-size: 24px;
  color: #666666;
}

.footer>.iconList>li {
  float: left;
  margin-left: 15px;
  cursor: pointer;
}

.ICP {
  position: absolute;
  z-index: 30;
  list-style: none;
  bottom: 40px;
  right: 50px;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}

.LoginMain {
  width: 600px;
  height: 500px;
  text-align: center;
  margin: 0px 0 0 -50px;
  left: 37%;
  position: absolute;
  padding: 50px 0;
  /* background-color: #fff;
  opacity: 0.6; */
}

.login-form {
  width: 40%;
  height: 100%;
  margin: auto auto;
  /* background-color: #fff; */
}

.LoginMain .login-form input {
  width: 100%;
  background: transparent;
  border-bottom: 1px solid #4D4D4D !important;
  color: #4D4D4D;
  font-size: 24px;
  padding: 0px 0px 10px 50px;
}

.login-form input:focus {
  outline: none;
  border: none;
}

.LoginMain .login-form .iconfont {
  /* color: #000; */
  color: #FFFFFF;
  font-size: 30px;
  float: left;
  position: relative;
  top: 40px;
  margin-bottom: 5px;
}

.login-form input:focus {
  outline: none;
  border: none;
}

.LoginMain .login-title {
  font-size: 50px;
  font-family: Helvetica;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 6px;
  margin: 50px 0px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.btnLogin {
  margin-top: 50px;
  width: 100%;
  color: #fff;
}

.btnLogin:hover {
  color: #fff;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 设置灰色透明图层的颜色和透明度 */
}
</style>
